import {
  Badge,
  Spinner,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from 'flowbite-react';
import { formatDate } from '../lib';
import { Link } from 'react-router-dom';
import {
  EExchangeRateStatusEnum,
  ExchangeRateHistoryListResponse,
} from '@acme/domains';
import { useModal } from '@acme/foundation';
import { ExchangeRateForm } from './exchangeRateForm';
import { ExchanegeRateService, RoleEnum } from '@acme/api';
interface RateHistoryTableProps {
  data: ExchangeRateHistoryListResponse[];
  adminMode?: boolean;
  loading?: boolean;
}

export const RateHistoryTable = (props: RateHistoryTableProps) => {
  const { openModal, closeModal } = useModal();
  const handleApproveClick = () => {
    openModal({
      content: (
        <ExchangeRateForm
          onClose={closeModal}
          onSubmit={ExchanegeRateService.postApiV1ExchanegeRateCreate}
        />
      ),
      size: 'xl',
      modalType: 'custom',
    });
  };
  if (props.loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex items-center justify-center py-8">
          <Spinner size="lg" />
          <span className="ml-3 text-gray-600">Загрузка истории курса...</span>
        </div>
      </div>
    );
  }

  return (
    <Table hoverable>
      <TableHead>
        <TableRow>
          <TableHeadCell>Время обновления</TableHeadCell>
          <TableHeadCell>Новые данные</TableHeadCell>
          <TableHeadCell>Старые данные</TableHeadCell>
          <TableHeadCell>Действителен до</TableHeadCell>
          <TableHeadCell>Кем был изменен</TableHeadCell>
        </TableRow>
      </TableHead>
      <TableBody className="divide-y text-sm font-normal">
        {props.data?.map((rate, index) => (
          <TableRow key={index}>
            <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
              {formatDate(rate.updatedAt)}
            </TableCell>
            <TableCell className="whitespace-nowrap">
              <div className="flex gap-2.5">
                {rate.newData?.status !== EExchangeRateStatusEnum.Blocked ? (
                  rate.newData?.ranges?.map((course, index) => (
                    <div
                      className={`flex gap-2 ${rate.newData?.status === EExchangeRateStatusEnum.IsEditedByNotOwner ? 'text-yellow-500' : 'text-gray-500'}`}
                    >
                      {`Курс ${index + 1}`}:
                      <div
                        className={
                          rate.newData?.status ===
                          EExchangeRateStatusEnum.IsEditedByNotOwner
                            ? 'text-yellow-800'
                            : 'text-gray-900'
                        }
                      >
                        {course.price}
                      </div>
                    </div>
                  ))
                ) : props.adminMode ? (
                  <div className="text-sm font-medium text-gray-500 gap-2">
                    Курс заблокирован. Ожидаем подтверждения от ПЛ
                  </div>
                ) : (
                  <div className="flex text-sm font-medium text-gray-500 gap-2">
                    Курс заблокирован, необходимо:
                    <div
                      className="text-brand-purple-900 cursor-pointer"
                      onClick={() => handleApproveClick()}
                    >
                      Подтверждение курса
                    </div>
                  </div>
                )}
              </div>
            </TableCell>
            <TableCell className="whitespace-nowrap">
              <div className="flex gap-2.5">
                {rate.previousData?.ranges?.map((course, index) => (
                  <div className="flex gap-2 text-gray-500">
                    {`Курс ${index + 1}`}:
                    <div className="text-gray-900">{course.price}</div>
                  </div>
                ))}
              </div>
            </TableCell>
            <TableCell className="text-gray-900">
              {formatDate(rate.newData?.expireAt)}
            </TableCell>
            <TableCell className="text-primary-600 flex items-center gap-2">
              <Badge color={'purple'}>
                {rate.initiatorUserOrganizationRole === RoleEnum.Admin
                  ? 'УО'
                  : 'ПЛ'}
              </Badge>
              <Link to={`users/${rate.initiatorUserId}`}>
                {rate.initiatorUserName}
              </Link>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
